<template>
  <div class="login-container">
    <div class="login-card">
      <h1 class="login-title">Welcome back!</h1>
      <p class="login-subtitle">Access your Repair Stand Maintenance Dashboard</p>
      <button @click="loginClick" class="login-button">
        <i class="fas fa-sign-in-alt"></i> Login
      </button>
    </div>
  </div>
</template>

<script>
import keycloak from '@/keycloak';
import { homeUrl } from '@/config/envVariablesConfig';

export default {
  methods: {
    loginClick() {
      keycloak.login({ redirectUri: homeUrl });
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(145deg, #e0eafc, #cfdef3);
}

.login-card {
  background-color: white;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 90%;
}

.login-title {
  font-size: 24px;
  margin-bottom: 10px;
  color: #2c3e50;
}

.login-subtitle {
  font-size: 16px;
  margin-bottom: 30px;
  color: #7f8c8d;
}

.login-button {
  background-color: #007bff;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.login-button i {
  margin-right: 8px;
}

.login-button:hover {
  background-color: #0056b3;
}
</style>
